import * as React from "react";
import { connect } from "react-redux";
import * as Redux from "redux";

import TeacherPreviewToggle from './teacherPreviewToggle';

import { TrackAnalyticsEvent } from '../actions/analytics';
import { Events } from '../modules/analytics';
import '../styles/headerStyling.scss';
import { getParameterByName, hasTeacherPreview } from '../../Shared/index';
import { getActivitySteps, getActivityStepLabels } from '../helpers/containerActionHelpers';
import { ACTIVE, COMPLETE, INACTIVE } from "../../../constants/evidence";

export const TOOL_TAG_LABEL = 'Reading for Evidence'

const logoSrc = `${window.postbuildEnv.CDN_URL}/images/logos/quill-logo-white.svg`
const mobileLogoSrc = `${window.postbuildEnv.CDN_URL}/images/logos/quill-logo-white-mobile.svg`
const checkIconSrc = `${window.postbuildEnv.CDN_URL}/images/icons/xs/check.svg`

export class Header extends React.Component<any, any> {
  constructor(props: any) {
    super(props)

    this.state = {
      sessionID: getParameterByName('student', window.location.href)
    }
  }

  goToLMS = () => {
    window.location.href = "/"
  }

  trackSaveAndExitEvent = () => {
    const { dispatch, previewShowing } = this.props
    const { sessionID, } = this.state

    if(!previewShowing) {
      const activityID = getParameterByName('uid', window.location.href)
      dispatch(TrackAnalyticsEvent(Events.EVIDENCE_ACTIVITY_SAVED, {
        activityID: activityID,
        sessionID
      }))
    }
  }

  saveAndExit = () => {
    const { sessionID, } = this.state
    this.trackSaveAndExitEvent()
    if (sessionID) {
    } else {
      this.goToLMS()
    }
  }

  handleOnClick = () => {
    this.saveAndExit()
  }

  handleTogglePreview = () => {
    const { onTogglePreview } = this.props;
    onTogglePreview();
  }

  // The steps and the conjunction names used to be two separate elements; they are one now, so
  // each step carries its own name rather than the activity type being spelled out alongside.
  stepState = (step: number) => {
    const { session } = this.props;
    const { activeStep, activityIsComplete } = session;

    if (activityIsComplete || step < activeStep) { return COMPLETE }
    if (step === activeStep) { return ACTIVE }
    return INACTIVE
  }

  renderProgress = () => {
    const { activities } = this.props;
    const steps = getActivitySteps(activities);
    const labels = getActivityStepLabels(activities);

    return (
      <ol className="header-progress">
        {steps.map((step, index) => {
          const state = this.stepState(step)
          return (
            <li className="header-progress-step" key={step}>
              {index > 0 && <span aria-hidden="true" className="header-progress-connector" />}
              <span aria-current={state === ACTIVE ? 'step' : undefined} className={`header-progress-pill ${state}`}>
                <span className="header-progress-marker">
                  {state === COMPLETE ? <img alt="" src={checkIconSrc} /> : step}
                </span>
                <span className="header-progress-label">{labels[index]}</span>
                {state === COMPLETE && <span className="sr-only">complete</span>}
              </span>
            </li>
          )
        })}
      </ol>
    );
  }

  render() {
    const { isTeacher, previewShowing, isOnMobile } = this.props;
    const isNotTurk = !window.location.href.includes('turk')
    // Only teachers get the preview controls; students never see them. previewShowing can come
    // back as null before it settles, so it is read as a boolean rather than trusted directly.
    const showPreviewToggle = isTeacher || hasTeacherPreview();

    return (
      <header className="header">
        <div className="inner-header">
          <div className="header-left">
            {showPreviewToggle && <TeacherPreviewToggle onTogglePreview={this.handleTogglePreview} previewShowing={!!previewShowing} />}
            <a className="focus-on-dark header-logo" href={window.postbuildEnv.DEFAULT_URL}>
              <img alt="Quill.org logo" className="hide-on-desktop" src={mobileLogoSrc} />
              <img alt="Quill.org logo" className="hide-on-mobile" src={logoSrc} />
            </a>
            <span className="tool-tag">{TOOL_TAG_LABEL}</span>
          </div>
          {!isOnMobile && this.renderProgress()}
          <div className="header-right">
            {isNotTurk && <button className="save-and-exit focus-on-dark" onClick={this.handleOnClick} type="button"><span>Save and Exit</span></button>}
          </div>
        </div>
      </header>
    );
  }
};

const mapStateToProps = (state: any) => {
  return {
    session: state.session,
    activities: state.activities
  };
};

const mapDispatchToProps = (dispatch: Redux.Dispatch<any>) => {
  return {
    dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header)
